@if (isLoginRequired) {
  <a
    appRequireLogin
    appDebounceClick
    class="badge text-copy__btn pointer-cursor"
    [ngbTooltip]="'UI.Common.Copy-Hint' | translate"
    (debounceClick)="copyUrl(); $event.stopPropagation()"
  >
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </a>
} @else {
  <a
    container="body"
    class="badge text-copy__btn pointer-cursor"
    [ngbTooltip]="'UI.Common.Copy-Hint' | translate"
    (click)="copyUrl(); $event.stopPropagation()"
  >
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </a>
}

<ng-template #content>
  <ng-icon
    name="matLink"
    size="1rem"
    class="text-copy__icon"
  ></ng-icon>
  <small
    class="text-copy__hint-text text-muted ms-1"
    [ngClass]="isUrlCopied ? 'visible' : 'invisible'"
  >
    {{ 'UI.Common.Copied' | translate }}
  </small>
</ng-template>
